import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ObjectJournals } from "./ui";

export const ObjectJournalRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: `${routes.objects.journals()}`,
    element: createElement(ObjectJournals),
    children: [...rest],
  };
};
